import { homeConstants } from '../constants/home.constants';
import { entityConstants } from '../constants/entity.constants';
import { constants } from '../constants/global.constants';


const initState = {
  isCreateSampleProjectDialogOpen: false,
  isTaskDialogOpen: false,
  isImportScheduleDialogOpen: false,
  isProjectDialogOpen: false,
  inProjectWizard: false,
  newProject: null,
  isChangeSubDialogOpen: false,
  isLoading: false,
  isUserEditDrawerOpen: false,
  userEditDrawerInfo: null,
  changeTaskList: null,
  isStatusChangeDialogOpen: false,
  circularProgressLoadingOpen: false,
  editProjectId: null,
  scheduleDrawerId: null,
  scheduleTasks: null,
  scheduleDrawerName: ''
};

export function home(state = initState, action) {
  switch (action.type) {
    case homeConstants.TASKDIALOG_OPEN:
      return Object.assign({}, state, {
        isTaskDialogOpen: true
      });
    case homeConstants.IMPORT_SCHEDULE_OPEN:
      return Object.assign({}, state, {
        isImportScheduleDialogOpen: true
      });
    case homeConstants.IMPORT_SCHEDULE_CLOSED:
      const isInviteDialogOpen = action.openInviteDialog;
      return Object.assign({}, state, {
        isImportScheduleDialogOpen: false,
        inProjectWizard: isInviteDialogOpen,
        isInviteDialogOpen: isInviteDialogOpen
      });
    case homeConstants.TASKDIALOG_SELECT:
      return Object.assign({}, state, {
        isTaskDialogOpen: false
      });
    case homeConstants.TASKDIALOG_CLOSE:
      return Object.assign({}, state, {
        isTaskDialogOpen: false
      });
    case homeConstants.UPLOAD_TASKDIALOG_OPEN:
      return Object.assign({}, state, {
        isUploadTasksDialogOpen: true
      });
    case homeConstants.UPLOAD_TASKDIALOG_CLOSED:
      return Object.assign({}, state, {
        isUploadTasksDialogOpen: false
      });
    case homeConstants.ADD_PROJECT_DIALOG:
      return Object.assign({}, state, {
        isProjectDialogOpen: true
      });
    case homeConstants.EDIT_PROJECT_DIALOG:
      return Object.assign({}, state, {
        isProjectDialogOpen: true,
        editProjectId: action.editProjectId
      });
    case entityConstants.ADD_PROJECT_SUCCESS:
      return Object.assign({}, state, {
        isProjectDialogOpen: false,
        editProjectId: null,
        isImportScheduleDialogOpen: true,
        inProjectWizard: true,
        selectedProjectId: action.selectedProjectId
      });
    case entityConstants.CLOSE_PROJECT_DIALOG:
      return Object.assign({}, state, {
        isProjectDialogOpen: false,
        editProjectId: null,
        isImportScheduleDialogOpen: false,
        inProjectWizard: false
      });

    case homeConstants.INVITEDIALOG_OPEN:
      return Object.assign({}, state, {
        isInviteDialogOpen: true
      });
    case homeConstants.INVITEDIALOG_CLOSE:
      return Object.assign({}, state, {
        isInviteDialogOpen: false,
        inProjectWizard: false
      });
    case homeConstants.MOREMENU_OPEN:
      return Object.assign({}, state, {
        moreMenuAchor: action.moreMenuAchor
      });
    case homeConstants.MOREMENU_CLOSE:
      return Object.assign({}, state, {
        moreMenuAchor: null
      });
    case homeConstants.READRECEIPT_OPEN:
      return Object.assign({}, state, {
        readReceiptRoute: action.readReceiptRoute
      });
    case homeConstants.READRECEIPT_CLOSE:
      return Object.assign({}, state, {
        readReceiptRoute: null
      });
    case homeConstants.SUBDIALOG_OPEN:
      return Object.assign({}, state, {
        isChangeSubDialogOpen: true
      });
    case homeConstants.SUBDIALOG_CLOSE:
      return Object.assign({}, state, {
        isChangeSubDialogOpen: false
      });
    case constants.OPEN_SCHEDULE_DRAWER:
      return Object.assign({}, state, {
          scheduleDrawerId: action.scheduleId,
          scheduleDrawerName: action.scheduleName,
          scheduleDrawerTasks: action.scheduleTasks,
         })
      
    case constants.CLOSE_SCHEDULE_DRAWER:
      return Object.assign({}, state, {
          scheduleDrawerId: null,
          scheduleDrawerName: ''
         })
      
    case homeConstants.SAMPLE_PROJECT_DIALOG_OPEN:
      return Object.assign({}, state, {
         isCreateSampleProjectDialogOpen: true
      })
    case homeConstants.SAMPLE_PROJECT_DIALOG_CLOSE:
      return Object.assign({}, state, {
         isCreateSampleProjectDialogOpen: false 
        })
    case homeConstants.NOT_LOADING:
      return Object.assign({}, state, { 
        isLoading: false 
      })
    case homeConstants.IS_LOADING:
      return Object.assign({}, state, {
        isLoading: true 
      })
    case homeConstants.OPEN_USER_EDIT_DRAWER:
      return Object.assign({}, state, {

          isUserEditDrawerOpen: true,
          userEditDrawerInfo: action.editBoardInfo
        })
    case homeConstants.CLOSE_USER_EDIT_DRAWER:
      return Object.assign({}, state, {
         isUserEditDrawerOpen: false 
      })
    case homeConstants.STATUSCHANGEDIALOG_OPEN:
      return Object.assign({}, state, {
          isStatusChangeDialogOpen: true,
          changeTaskList: action.taskList
        })
    case homeConstants.STATUSCHANGEDIALOG_CLOSE:
      return Object.assign({}, state, {
          isStatusChangeDialogOpen: false,
          changeTaskList: null
        })
    case homeConstants.CIRCULAR_PROGRESS_LOADING_OPEN:
      return Object.assign({}, state, {
          circularProgressLoadingOpen: true
        })
    case homeConstants.CIRCULAR_PROGRESS_LOADING_CLOSE:
      return Object.assign({}, state, {
          circularProgressLoadingOpen: false
        })
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/home.reducer.ts